module.exports = __webpack_public_path__ + "img/stick-on-2.565b7280.jpg";